export default __webpack_public_path__ + "static/media/stands_ind_-construlita.22f33c3c.jpg";